import React from "react";

export interface FilterChip {
  id: string;
  label: string;
  count: number;
}

interface FilterChipsProps {
  chips: FilterChip[];
  activeId: string;
  onChange: (id: string) => void;
  ariaLabel: string;
  /** Horizontal pills (default) or a vertical topic rail. */
  orientation?: "horizontal" | "vertical";
}

const FilterChips: React.FC<FilterChipsProps> = ({
  chips,
  activeId,
  onChange,
  ariaLabel,
  orientation = "horizontal",
}) => (
  <div
    className={`library-filter-bar__chips${
      orientation === "vertical" ? " library-filter-bar__chips--vertical" : ""
    }`}
    role="group"
    aria-label={ariaLabel}
  >
    {chips.map(chip => {
      const isActive = activeId === chip.id;
      const isInactive = chip.count === 0;
      return (
        <button
          key={chip.id}
          type="button"
          className={`library-filter-chip${
            orientation === "vertical" ? " library-filter-chip--nav" : ""
          }${isActive ? " is-active" : ""}${isInactive ? " is-inactive" : ""}`}
          aria-pressed={isActive}
          onClick={() => onChange(chip.id)}
        >
          {orientation === "vertical" ? (
            <>
              <span className="library-filter-chip__label">{chip.label}</span>
              <span className="library-filter-chip__count">{chip.count}</span>
            </>
          ) : (
            <>
              {chip.label} · {chip.count}
            </>
          )}
        </button>
      );
    })}
  </div>
);

export default FilterChips;
